import React, { useRef, useCallback } from "react";
import Pagination from '../Pagination';

const List = ({
    type: Tag,
    id,
    classname,
    extraData,
    selectedId,
    cellTemplate: CellTemplate,
    cellLoadingTemplate,
    isCellLoading,
    isPagination,
    onScrollHandler,
    onItemClick,
    onCellClick,
    onDeleteClick,
    data = []
}) => {
    const scrollRef = useRef(null);
    const isScrolling = useRef(false);

    const handleScroll = useCallback(() => {
        const el = scrollRef.current;
        if (!el) return;

        const atBottom = (el.scrollTop + el.offsetHeight) >= (el.scrollHeight - 10);

        if (atBottom && data.length && !isScrolling.current) {
            isScrolling.current = true;
            onScrollHandler?.();
        } else if (!atBottom) {
            isScrolling.current = false;
        }
    }, [data.length, onScrollHandler]);

    const handlePaginationClick = useCallback(
        (pageNumber) => onItemClick?.({ Page: pageNumber }),
        [onItemClick]
    );

    return (
        <Tag
            id={id || "cardScroll"}
            className={classname || "workKardScroll scrollArea"}
            onScroll={handleScroll}
            ref={scrollRef}
        >
            {isCellLoading && cellLoadingTemplate}

            {data.map((item) => (
                <CellTemplate
                    key={item.id ?? item.key ?? item.uuid ?? item.activityId ?? item.workkardId}
                    data={item}
                    extraData={extraData ?? null}
                    selectedId={selectedId}
                    onItemClick={onItemClick}
                    onCellClick={onCellClick}
                    onDeleteClick={onDeleteClick}
                    isCellLoading={isCellLoading}
                />
            ))}

            {isPagination && (
                <Pagination
                    pagingModel={extraData?.pagingModel}
                    handlePagination={handlePaginationClick}
                />
            )}
        </Tag>
    );
};

export default List;